import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { Lang } from '../i18n/translations';
export function LanguageSwitcher({
  className = ''
}: {
  className?: string;
}) {
  const {
    lang,
    setLang
  } = useLanguage();
  const options: {
    value: Lang;
    label: string;
  }[] = [{
    value: 'ru',
    label: 'RU'
  }, {
    value: 'kk',
    label: 'KZ'
  }, {
    value: 'en',
    label: 'EN'
  }];
  return <div className={`inline-flex bg-gray-100/80 rounded-lg p-1 ${className}`} data-id="element-25">
      {options.map(option => <button key={option.value} onClick={() => setLang(option.value)} className={`px-2 py-1 text-xs font-bold rounded-md transition-all ${lang === option.value ? 'bg-white text-[#7C4DFF] shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} aria-label={`Switch to ${option.label}`} aria-current={lang === option.value ? 'true' : undefined} data-id="element-26">
          {option.label}
        </button>)}
    </div>;
}